import { html, LitElement } from 'lit-element';
import { unsafeSVG } from 'lit-html/directives/unsafe-svg';
import {
  sy_notification_info_16 as notificationInfo,
  sy_notification_error_16 as notificationError,
  sy_notification_verified_16 as notificationPositive,
  sy_notification_privacy_16 as notificationPrivacy,
  sy_notification_warning_16 as notificationWarning,
  sy_shapes_close_large as closeIcon,
} from '@aab/sc-aab-icon-set';
import Styles from './styles.scss';

export const ICON_TYPES = {
  info: notificationInfo,
  negative: notificationError,
  'system-error': notificationError,
  positive: notificationPositive,
  privacy: notificationPrivacy,
  warning: notificationWarning,
};

export default class AabNotification extends LitElement {
  constructor() {
    super();
    // Initialize LitElement properties here
    this.type = 'positive';
    this.closeIconAriaLabel = '';
  }

  static get properties() {
    return {
      notificationTitle: { type: String, attribute: 'notification-title' },
      type: { type: String },
      closeIconAriaLabel: { type: String, attribute: 'close-icon-aria-label' },
      closeIcon: { type: Boolean, attribute: 'close-icon' },
      screenReaderType: { type: String, attribute: 'screenreader-type' },
    };
  }

  static get styles() {
    return [Styles];
  }

  handleCloseIconClick() {
    const aabNotificationCloseIconClicked = new CustomEvent('aab-notification-close-icon-clicked', {
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(aabNotificationCloseIconClicked);
  }

  render() {
    return html`
    <div class="alert ${this.type} spt-2 pt-md-2 spx-2 rounded-4">
      <div class="sr-only">${this.screenReaderType}</div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-auto p-0 pr-1">
            <span class="icon" aria-hidden="true">${unsafeSVG(ICON_TYPES[this.type])}</span>
          </div>  
          <div class="col p-0">
            ${this.notificationTitle ? html`<p class="notification-title smb-1">${this.notificationTitle}</p>` : ''}
            <p class="notification-text smb-2 mb-md-2"><slot></slot></p>
            <div class="smb-2 mb-md-2"><slot name="link"></slot></div>
          </div>
          ${this.closeIcon ? html`
            <div class="col-auto p-0 pl-1">
              <button class="close-icon" @click="${() => this.handleCloseIconClick()}" aria-label=${this.closeIconAriaLabel} >
                <span aria-hidden="true">${unsafeSVG(closeIcon)}</span>
              </button>
            </div>` : ''}
        </div>
      </div>
    </div>`;
  }
}
